module.exports = __webpack_public_path__ + "static/media/Banking-Details-JSSE.ed3dad7a.pdf";